export const RailsPdtConstants = {
  CountryCode: 'IN',
  TemplateId: '64631',
  TopicId: '448',
  LobName: 'rails',
  FunnelStep: {
    LANDING: 'landing',
    LISTING: 'listing',
    TRAVELLERS: 'travellers',
    REVIEW: 'review',
    THANKYOU: 'thankyou'
  },
  BaseEventAction: {
    LOAD_PAGE: 'on_page_load',
    EXIT_PAGE: 'on_page_exit',
    CLICK_BACK: 'on_click_back'
  },
  LandingEventAction: {
    CLICK_SEARCH: 'on_click_search'
  },
  ListingEventAction: {
    CLICK_TRAIN: 'on_click_train'
  },
  ReviewEventAction: {
    CLICK_PAY: 'on_click_pay'
  }
};
